import { render } from "./medicine-advice-detail.vue?vue&type=template&id=3dc2654c&scoped=true"
import script from "./medicine-advice-detail.vue?vue&type=script&lang=js"
export * from "./medicine-advice-detail.vue?vue&type=script&lang=js"

import "./medicine-advice-detail.vue?vue&type=style&index=0&id=3dc2654c&lang=scss&scoped=true"

import exportComponent from "/builds/gitlab-runner/ci/auto-build/hospital-user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc2654c"]])

export default __exports__